import React, { useState } from "react";
import "./style.css";
import Chip from "@mui/material/Chip";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DangerousOutlinedIcon from "@mui/icons-material/DangerousOutlined";
import { NotificationPlacement } from "antd/es/notification/interface";
import Tooltip from "@mui/material/Tooltip";
import { Card } from "@mui/material";
import { AcceptUser } from "../../userProfile/api/AcceptUser";
import { DeactiveUser } from "../../userProfile/api/DeactivateUser";
import {
  Avatar,
  Button,
  Popconfirm,
  PopconfirmProps,
  message,
  notification,
} from "antd";
export const UserCard = ({ gradientColor, user }: any) => {
  // Destructure user data
  // console.log(user);
  const { id, fullName, email, status, account } = user;
  // console.log(user);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [api, contextHolder] = notification.useNotification();

  const openNotification2 = (placement: NotificationPlacement) => {
    api.success({
      message: "تم تفعيل المستخدم بنجاح",
      description: "تم تفعيل المستخدم بنجاح",
      placement,
      duration: 3,
    });
  };
  const openDeactiveUserNotification = (placement: NotificationPlacement) => {
    api.success({
      message: "تم الغاء تفعيل المستخدم بنجاح",
      description: "تم الغاء تفعيل المستخدم بنجاح",
      placement,
      duration: 3,
    });
  };

  const UserAcceptConfirm: PopconfirmProps["onConfirm"] = (e: any) => {
    // message.success("Click on Yes");
    e.stopPropagation();
    const Accept = async () => {
      const response = await AcceptUser(id);
      // console.log(response);
      if (response) {
        openNotification2("topRight");
      }
    };
    Accept();
  };
  const UserAcceptCancel: PopconfirmProps["onCancel"] = (e: any) => {
    e.stopPropagation();
    // console.log(e);
    // message.error("Click on No");
  };
  const UserDeactivateConfirm: PopconfirmProps["onCancel"] = (e: any) => {
    e.stopPropagation();
    const Deactive = async () => {
      const response = await DeactiveUser(id);
      // console.log(response);
      if (response) {
        openDeactiveUserNotification("topRight");
      }
    };
    Deactive();
  };
  const UserDeactivateCancel: PopconfirmProps["onCancel"] = (e: any) => {
    e.stopPropagation();
    // console.log(e);
    // message.error("Click on No");
  };
  // console.log(account);

  const linearGradientId = `linear-gradient-${Math.random()}`;
  const patternId = `pattern-${Math.random()}`;
  return (
    <Card className="h-fit w-full ">
      {contextHolder}
      <div className="card">
        <div className="card__img">
          <svg xmlns="http://www.w3.org/2000/svg">
            <rect fill="#ffffff"></rect>
            <defs>
              <linearGradient
                id={linearGradientId}
                gradientUnits="userSpaceOnUse"
                x1="0"
                x2="0"
                y1="0"
                y2="100%"
                gradientTransform="rotate(222,648,379)">
                <stop offset="0" stopColor="#ffffff"></stop>
                <stop offset="1" stopColor={gradientColor}></stop>
              </linearGradient>
              <pattern
                patternUnits="userSpaceOnUse"
                id={patternId}
                width="300"
                height="250"
                x="0"
                y="0"
                viewBox="0 0 1080 900">
                <g fillOpacity="0.5">
                  <polygon fill="#444" points="90 150 0 300 180 300"></polygon>
                  <polygon points="90 150 180 0 0 0"></polygon>
                  <polygon fill="#AAA" points="270 150 360 0 180 0"></polygon>
                  <polygon
                    fill="#DDD"
                    points="450 150 360 300 540 300"></polygon>
                  <polygon fill="#999" points="450 150 540 0 360 0"></polygon>
                  <polygon points="630 150 540 300 720 300"></polygon>
                  <polygon fill="#DDD" points="630 150 720 0 540 0"></polygon>
                  <polygon
                    fill="#444"
                    points="810 150 720 300 900 300"></polygon>
                  <polygon fill="#FFF" points="810 150 900 0 720 0"></polygon>
                  <polygon
                    fill="#DDD"
                    points="990 150 900 300 1080 300"></polygon>
                  <polygon fill="#444" points="990 150 1080 0 900 0"></polygon>
                  <polygon fill="#DDD" points="90 450 0 600 180 600"></polygon>
                  <polygon points="90 450 180 300 0 300"></polygon>
                  <polygon
                    fill="#666"
                    points="270 450 180 600 360 600"></polygon>
                  <polygon
                    fill="#AAA"
                    points="270 450 360 300 180 300"></polygon>
                  <polygon
                    fill="#DDD"
                    points="450 450 360 600 540 600"></polygon>
                  <polygon
                    fill="#999"
                    points="450 450 540 300 360 300"></polygon>
                  <polygon
                    fill="#999"
                    points="630 450 540 600 720 600"></polygon>
                  <polygon
                    fill="#FFF"
                    points="630 450 720 300 540 300"></polygon>
                  <polygon points="810 450 720 600 900 600"></polygon>
                  <polygon
                    fill="#DDD"
                    points="810 450 900 300 720 300"></polygon>
                  <polygon
                    fill="#AAA"
                    points="990 450 900 600 1080 600"></polygon>
                  <polygon
                    fill="#444"
                    points="990 450 1080 300 900 300"></polygon>
                  <polygon fill="#222" points="90 750 0 900 180 900"></polygon>
                  <polygon points="270 750 180 900 360 900"></polygon>
                  <polygon
                    fill="#DDD"
                    points="270 750 360 600 180 600"></polygon>
                  <polygon points="450 750 540 600 360 600"></polygon>
                  <polygon points="630 750 540 900 720 900"></polygon>
                  <polygon
                    fill="#444"
                    points="630 750 720 600 540 600"></polygon>
                  <polygon
                    fill="#AAA"
                    points="810 750 720 900 900 900"></polygon>
                  <polygon
                    fill="#666"
                    points="810 750 900 600 720 600"></polygon>
                  <polygon
                    fill="#999"
                    points="990 750 900 900 1080 900"></polygon>
                  <polygon fill="#999" points="180 0 90 150 270 150"></polygon>
                  <polygon fill="#444" points="360 0 270 150 450 150"></polygon>
                  <polygon fill="#FFF" points="540 0 450 150 630 150"></polygon>
                  <polygon points="900 0 810 150 990 150"></polygon>
                  <polygon fill="#222" points="0 300 -90 450 90 450"></polygon>
                  <polygon fill="#FFF" points="0 300 90 150 -90 150"></polygon>
                  <polygon
                    fill="#FFF"
                    points="180 300 90 450 270 450"></polygon>
                  <polygon
                    fill="#666"
                    points="180 300 270 150 90 150"></polygon>
                  <polygon
                    fill="#222"
                    points="360 300 270 450 450 450"></polygon>
                  <polygon
                    fill="#FFF"
                    points="360 300 450 150 270 150"></polygon>
                  <polygon
                    fill="#444"
                    points="540 300 450 450 630 450"></polygon>
                  <polygon
                    fill="#222"
                    points="540 300 630 150 450 150"></polygon>
                  <polygon
                    fill="#AAA"
                    points="720 300 630 450 810 450"></polygon>
                  <polygon
                    fill="#666"
                    points="720 300 810 150 630 150"></polygon>
                  <polygon
                    fill="#FFF"
                    points="900 300 810 450 990 450"></polygon>
                  <polygon
                    fill="#999"
                    points="900 300 990 150 810 150"></polygon>
                  <polygon points="0 600 -90 750 90 750"></polygon>
                  <polygon fill="#666" points="0 600 90 450 -90 450"></polygon>
                  <polygon
                    fill="#AAA"
                    points="180 600 90 750 270 750"></polygon>
                  <polygon
                    fill="#444"
                    points="180 600 270 450 90 450"></polygon>
                  <polygon
                    fill="#444"
                    points="360 600 270 750 450 750"></polygon>
                  <polygon
                    fill="#999"
                    points="360 600 450 450 270 450"></polygon>
                  <polygon
                    fill="#666"
                    points="540 600 630 450 450 450"></polygon>
                  <polygon
                    fill="#222"
                    points="720 600 630 750 810 750"></polygon>
                  <polygon
                    fill="#FFF"
                    points="900 600 810 750 990 750"></polygon>
                  <polygon
                    fill="#222"
                    points="900 600 990 450 810 450"></polygon>
                  <polygon fill="#DDD" points="0 900 90 750 -90 750"></polygon>
                  <polygon
                    fill="#444"
                    points="180 900 270 750 90 750"></polygon>
                  <polygon
                    fill="#FFF"
                    points="360 900 450 750 270 750"></polygon>
                  <polygon
                    fill="#AAA"
                    points="540 900 630 750 450 750"></polygon>
                  <polygon
                    fill="#FFF"
                    points="720 900 810 750 630 750"></polygon>
                  <polygon
                    fill="#222"
                    points="900 900 990 750 810 750"></polygon>
                  <polygon
                    fill="#222"
                    points="1080 300 990 450 1170 450"></polygon>
                  <polygon
                    fill="#FFF"
                    points="1080 300 1170 150 990 150"></polygon>
                  <polygon points="1080 600 990 750 1170 750"></polygon>
                  <polygon
                    fill="#666"
                    points="1080 600 1170 450 990 450"></polygon>
                  <polygon
                    fill="#DDD"
                    points="1080 900 1170 750 990 750"></polygon>
                </g>
              </pattern>
            </defs>
            <rect
              x="0"
              y="0"
              fill={`url(#${linearGradientId})`}
              width="100%"
              height="100%"></rect>
            <rect
              x="0"
              y="0"
              fill={`url(#${patternId})`}
              width="100%"
              height="100%"></rect>
          </svg>
        </div>
        <div className="w-full ml-[60%]">
          {/* <div className="border-2 border-black"> */}
          <Avatar
            className={`card__avatar top-20`}
            size="large"
            style={{ backgroundColor: gradientColor }}>
            {" "}
            <div className="text-4xl">{user.fullName.charAt(0)}</div>
          </Avatar>
          {/* </div> */}
        </div>
        <div className="card__title">{fullName}</div>
        <div className="card__subtitle">{email}</div>
        <div className="flex justify-between items-center py-4 w-[30%]">
          {account ? (
            account.isOffice ? (
              <Chip label="مكتب" />
            ) : (
              <Chip label="زبون" />
            )
          ) : (
            <Chip label="غير متاح" />
          )}

          <div>
            {status === "pending" ? (
              <Tooltip title="not-verified" style={{ color: "red" }}>
                <DangerousOutlinedIcon />
              </Tooltip>
            ) : (
              <Tooltip title="verified" style={{ color: "green" }}>
                <CheckCircleOutlineIcon />
              </Tooltip>
            )}
          </div>
        </div>
        {/* <div className="card__wrapper">
          <button className="card__btn">Button</button>
          <button className="card__btn card__btn-solid">Button</button>
        </div> */}
        {/* {status === "pending" ? (
          <Button
            type="primary"
            className="m-5"
            onClick={(e) => {
              e.stopPropagation(); // This prevents the click event from bubbling up to parent elements
              // console.log("hi");
            }}>
            تفعيل
          </Button>
        ) : (
          <Button
            danger
            className="m-5"
            onClick={(e) => {
              e.stopPropagation(); // This prevents the click event from bubbling up to parent elements
              // console.log("hi");
            }}>
            تعطيل
          </Button>
        )} */}
        {/* <div>
          {status == "pending" ? (
            <Popconfirm
              title="تفعيل المستخدم"
              description="هل انت متاكد من تفعيل هذا المستخدم"
              onConfirm={UserAcceptConfirm}
              onCancel={UserAcceptCancel}
              okText="نعم"
              cancelText="لا">
              <Button
                type="primary"
                className="m-5"
                size="large"
                onClick={(e) => {
                  e.stopPropagation(); // This prevents the click event from bubbling up to parent elements
                  // console.log("hi");
                }}>
                تفعيل
              </Button>
            </Popconfirm>
          ) : (
            <Popconfirm
              title="الغاء تفعيل المستخدم"
              description="هل انت متاكد من الغاء تفعيل هذا المستخدم"
              onConfirm={UserDeactivateConfirm}
              onCancel={UserDeactivateCancel}
              okText="نعم"
              cancelText="لا">
              <Button
                danger
                size="large"
                className="m-5"
                onClick={(e) => {
                  e.stopPropagation(); // This prevents the click event from bubbling up to parent elements
                  // console.log("hi");
                }}>
                تعطيل
              </Button>
            </Popconfirm>
          )}
        </div> */}
      </div>
    </Card>
  );
};
